import domtoimage from 'dom-to-image'
import Compressor from 'compressorjs'
import { Iselect } from 'declare'
import CryptoJS from 'crypto-js'
import cookie from 'js-cookie'
import jsPDF from 'jspdf'
import axios from 'axios'
import api from 'api'
import { encode } from 'js-base64'

export const customUploadImage = (event: any, accept: string) => {
  return new Promise(async (resolve, reject) => {
    const file = event.target.files[0]
    if (!file) return false
    const { type, size } = file
    if (accept !== 'image/*' && accept.indexOf(type) === -1) {
      reject({
        status: false,
        msg: `请上传正确格式${accept}的图片文件`,
      })
    }
    if (size && size < file.size / 1024 / 1025) {
      reject({
        status: false,
        msg: `请上传不超过5M的图片文件`,
      })
    }
    // console.log(`上传前大小${size}`);
    new Promise(() => {
      new Compressor(file, {
        quality: 0.8,
        convertSize: 1000000,
        convertTypes: ['image/png', 'image/webp', 'image/jpg', 'image/jpeg'],
        success(result: any) {
          // console.log(`上传后大小${result.size}`, result);
          uploadFunc(result)
            .then((url) => {
              resolve(url)
            })
            .catch((error) => {
              reject(error)
            })
        },
        error(err: any) {
          reject(err)
        },
      })
    })
  })
}

export const customUploadFile = (
  file: any,
  accept: string,
  bigSize?: number,
  notLimit: boolean = true,
) => {
  return new Promise(async (resolve, reject) => {
    const { name, size } = file
    if (!file) return false
    if (accept.indexOf(name.split('.')[name.split('.').length - 1]) === -1) {
      reject({
        status: false,
        msg: `请上传正确的格式类型文件`,
      })
    }
    if (notLimit) {
    } else {
      if (size && size / 1024 / 1025 > (bigSize ? bigSize : 20)) {
        reject({
          status: false,
          msg: `请上传不超过${bigSize ? bigSize : 20}M的文件`,
        })
      }
    }

    try {
      const url = await uploadFunc(file)
      let obj: any = { detail: url }
      if (name) {
        obj.name = name.substring(0, name.lastIndexOf('.'))
        obj.suffix = name.substring(name.lastIndexOf('.') + 1)
        obj.size = size
      }
      resolve(obj)
    } catch (error) {
      reject(error)
    }
  })
}

export const uploadFunc = async (file: File) => {
  const { type, name } = file
  const suffix = name.split('.').pop()
  const result = await api.upload()
  try {
    let res = result.data
    const formdata = new FormData()
    formdata.append('key', `${res.path}/${res.fileName}.${suffix}`)
    formdata.append('token', res.token)
    formdata.append('content-type', type)
    formdata.append('file', file)
    let action = res.uploadUrl
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    }
    let url: string = ''
    if (res)
      url = `${res?.uploadUrl}/${res.path}/${res.fileName}.${suffix}`.toString()
    try {
      await axios.post(action, formdata, config)
      return url
    } catch (error) {
      return ''
    }
  } catch (error) {}
}
export const customUploadFileHaveReturn = (
  file: any,
  accept: string,
  bigSize?: number,
) => {
  return new Promise(async (resolve, reject) => {
    const { name, size } = file
    if (!file) return false
    if (accept.indexOf(name.split('.')[name.split('.').length - 1]) === -1) {
      reject({
        status: false,
        msg: `请上传正确的格式类型文件`,
      })
    }
    if (size && size / 1024 / 1025 > (bigSize ? bigSize : 20)) {
      reject({
        status: false,
        msg: `请上传不超过${bigSize ? bigSize : 20}M的文件`,
      })
    }
    try {
      const formdata = new FormData()
      formdata.append('file', file)
      const data = await api.importPersonList(formdata)
      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}
// base64转blob 文件对象
export const convertBase64UrlToImgFile = (dataurl: any, filename: string) => {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1] /*文件类型*/
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export const convertBase64UrlToBlob = (urlData: string) => {
  //去掉url的头，并转换为byte
  var split = urlData.split(',')
  var bytes = window.atob(split[1])
  //处理异常,将ascii码小于0的转换为大于0
  var ab = new ArrayBuffer(bytes.length)
  var ia = new Uint8Array(ab)
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new Blob([ab], { type: split[0] })
}

export const blobToFile = (theBlob: Blob, fileName: string) => {
  console.log(theBlob.type)
  const type = theBlob.type.substring(5, theBlob.type.length - 7)
  const name = fileName + `.${type.split('/')[1]}`
  ;(theBlob as any).lastModifiedDate = new Date() // 文件最后的修改日期
  ;(theBlob as any).name = name // 文件名
  return new File([theBlob], (theBlob as any).name, {
    type: type,
    lastModified: Date.now(),
  })
}
// 转url
export const blobToUrl = (blob: any, callback: Function) => {
  const reader = new FileReader()
  reader.onload = function (e: any) {
    callback(e.target.result)
  }
  reader.readAsDataURL(blob)
}
// 根据地址获取文件名
export const urlToName = (url: string) => {
  let arr = url.split('/')
  let len = arr.length
  return arr[len - 1]
}

export const dealFile = (content: any) => {
  if (content && content.includes('{')) {
    return JSON.parse(content)
  }
  return {}
}

export const dealNoticeFile = (content: any) => {
  if (content && content.includes('{')) {
    return JSON.parse(JSON.parse(content)?.content)
  }
  return []
}

export const getFileImg = (suffix: string) => {
  return suffix?.indexOf('doc') > -1
    ? 'wold'
    : suffix?.indexOf('xls') > -1
      ? 'excel'
      : suffix?.indexOf('pdf') > -1
        ? 'pdf'
        : suffix?.indexOf('ppt') > -1
          ? 'ppt'
          : 'icon-default'
}

// 格式化链接数据

export const formatLink = (str: string) => {
  const json = JSON.parse(str)
  return json
}

// 防抖
export const debounce = (func: Function, delay: number) => {
  // 一个setTimeout对象的签名（初始值应该为undefined）
  var timer: number
  return function () {
    // timer不是空的情况下，说明执行过 "timer = window.setTimeout(func, delay);" 这行代码
    // 这意味着本函数被调用过一次
    if (timer) {
      // 在上面的情况之后，每次调用都会使setTimeout对象的延时复位
      window.clearTimeout(timer)
    }
    // 设置延迟delay事件后执行
    timer = window.setTimeout(func, delay)
  }
}

export const getName = (
  arr: Array<{ label: string; value: any }>,
  value: any,
) => {
  let val = arr?.find((el: any) => {
    return el.value === value
  }) as any
  return val?.label || ''
}
// 非严格等
export const getName2 = (
  arr: Array<{ label: string; value: any }>,
  value: any,
) => {
  let val = arr?.find((el: any) => {
    return el.value == value
  }) as any
  return val?.label || ''
}

// 添加唯一id
export const addId = (arr: Array<any> = []) => {
  if (!arr) return []
  if (arr.length) {
    arr.forEach((el: any, index: any) => {
      if (!el) return
      arr[index].subIndex = index
      arr[index].xh = arr?.length - index
    })
  }
  return arr
}

// 处理树数据
export const disableUserDept = (arr: Array<any>) => {
  let callBack = (arr: Array<any>) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].parentId) {
        arr[i].disabled = true
      }
      if (arr[i]?.children && arr[i].children.length) {
        callBack(arr[i].children)
      }
    }
  }
  callBack(arr)
  return arr
}

// 把数据处理成select格式
export const dealDataBackSelectValues = (
  data: any[],
  label: string,
  value: string,
): Iselect[] => {
  let arr: Iselect[] = []
  data.forEach((el) => {
    let obj = {
      label: el[label],
      value: el[value],
    }
    arr.push(obj)
  })
  return arr
}

// 选择组织架构uuid转userId TreeSelect
export const findSelectData = (treeData: Iselect[], id: string) => {
  let userId = ''
  const getData = (arr: Array<any>) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value === id) {
        userId = arr[i].id
        break
      }
      if (arr[i]?.children && arr[i].children.length) {
        getData(arr[i].children)
      }
    }
  }
  getData(treeData)
  return userId
}

// 查找obj
export const findSelectObj = (treeData: Iselect[], id: string) => {
  let obj: any
  const getData = (arr: Array<any>) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value === id) {
        obj = arr[i]
        break
      }
      if (arr[i]?.children && arr[i].children.length) {
        getData(arr[i].children)
      }
    }
  }
  getData(treeData)
  return obj
}

// 提交表单处理上传图片为字符串数组
export const handleDealPictureArray = (
  fileList: { photoUrl: string }[] = [],
) => {
  const newArray: string[] = []
  fileList.forEach((el) => {
    newArray.push(el?.photoUrl)
  })
  return newArray
}

// 根据图片地址数组回显
export const handleDealPictureEcho = (fileList: string[] = []) => {
  const newArray: { photoUrl: string }[] = []
  fileList.forEach((el) => {
    newArray.push({ photoUrl: el })
  })
  return newArray
}

// 数组元素上移下移
export const handleDealDataMove = (
  list: any[] = [],
  index: number,
  operationType: 'under' | 'down',
) => {
  let prevIndex = index - 1
  let nextIndex = index + 1

  if (prevIndex >= 0 && operationType === 'under') {
    // 上移
    // 如果前一个索引有效，交换当前元素与前一个元素
    ;[list[prevIndex], list[index]] = [list[index], list[prevIndex]]
  }

  if (nextIndex < list.length && operationType === 'down') {
    ;[list[nextIndex], list[index]] = [list[index], list[nextIndex]]
  }
  return list
}

// 根据userID返回名字
export const handleGetUserName = (list: any[], userIds: string[]) => {
  if (list.length) {
    const _list = list.filter((el) => userIds.includes(el?.userId))
    if (_list.length) {
      let nickNames: string[] = []
      _list.forEach((el) => {
        nickNames.push(el?.nickName)
      })
      return nickNames.join(' ')
    }
  }
  return ''
}

// 角色权限
export const getStationedUser2 = (serviceArr: string[]) => {
  let roles: any = cookie.get('roles') || []
  roles = JSON.parse(roles)
  // let serviceArr = ['kfContractor', 'kfContractorDirector', 'kfContractorSupervisor', 'kfContractorAreaSupervisor'];
  if (!roles.length) return []
  return serviceArr.filter((el: any) => {
    return roles.includes(el)
  })
}

// 根据div生成PDF
export const handleGeneratePDF = async (nodesDiv: any, name?: string) => {
  return new Promise((resolve) => {
    // 创建新的jsPDF实例
    const pdf = new jsPDF()
    domtoimage
      .toPng(nodesDiv.children[0], {
        width: 800,
        height: nodesDiv.scrollHeight,
        quality: 1,
      })
      .then((dataUrl) => {
        blobToUrl(convertBase64UrlToBlob(dataUrl), (imageUrl: any) => {
          // 添加图片到PDF
          const imgProps = pdf.getImageProperties(imageUrl)
          const pdfWidth = pdf.internal.pageSize.getWidth()
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width
          pdf.addImage(imageUrl, 'JPEG', 0, 0, pdfWidth, pdfHeight)

          // 保存生成的PDF
          pdf.save(`${name}.pdf`)
          resolve(true)
        })
      })
  })
}

// 递归处理组织架构数据
export const handleDealOrgData = (list: any[]) => {
  list.forEach((el: any) => {
    const { children, type } = el
    if (type === 1) {
      el['disabled'] = true
    }
    if (children && children.length) {
      handleDealOrgData(children) // 递归处理子节点
    }
  })
  return list
}

// 判定链接地址是视频还是图片
export const isImageOrVideo = (item: any, flag?: boolean) => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg']
  const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'flv', 'wmv', 'mov']

  let extension = ''
  if (!item) return false
  if (!flag) {
    if (isAndroid) {
      extension = item.url.split('.').pop().toLowerCase()
    } else {
      if (item?.file) {
        console.log(item, 'item')
        extension = `${(item?.file.type?.split('/'))[1]}`.toLowerCase()
      } else {
        extension = item.url.split('.').pop().toLowerCase()
      }
    }
  } else {
    extension = item.split('.').pop().toLowerCase()
  }

  return imageExtensions.includes(extension)
    ? 'image'
    : videoExtensions.includes(extension)
      ? 'video'
      : 'unknown'
}

// 处理区域数据颜色
export const handleDealMapAreaColor = (count: number) => {
  let color = ''
  if (count < 10000) {
    color = '#8EC687'
  } else if (count < 30000 && count > 10000) {
    color = '#54AD49'
  } else if (count < 50000 && count > 30000) {
    color = '#3A8531'
  } else if (count < 100000 && count > 50000) {
    color = '#23551C'
  } else {
    color = '#13380E'
  }
  return color
}

// 根据后缀返回icon地址
export const handleGetIconUrl = (str: string) => {
  const suffix = str.split('.').pop() as string
  switch (suffix) {
    case 'doc':
    case 'docx':
      return 'https://huahuiapp.obs.cn-south-1.myhuaweicloud.com/H5/customer/icon_word.pngg'
    case 'ppt':
    case 'pptx':
      return 'https://huahuiapp.obs.cn-south-1.myhuaweicloud.com/H5/customer/icon_ppt.png'
    case 'xls':
    case 'xlsx':
      return 'https://huahuiapp.obs.cn-south-1.myhuaweicloud.com/H5/customer/icon_excel.png'
    case 'pdf':
      return 'https://huahuiapp.obs.cn-south-1.myhuaweicloud.com/H5/customer/icon_pdf.png'
    default:
      return str
  }
}
// 数组去重
export const handleRemoveDupl = (arr: Array<any>) => {
  const uniqueArr = arr.reduce((acc, cur) => {
    const hasDuplicate = acc.some(
      (item: { value: any; label: any }) =>
        item.value === cur.value && item.label === cur.label,
    )
    if (!hasDuplicate) {
      acc.push(cur)
    }
    return acc
  }, [])
  return uniqueArr
}

// 解密
export const handleDecrypt = (data: string) => {
  if (!data) return null
  const secretKey = CryptoJS.enc.Base64.parse(
    process.env?.REACT_APP_secretKey || '',
  )
  const iv = CryptoJS.enc.Base64.parse(process.env?.REACT_APP_iv || '')
  const bytes = CryptoJS.AES.decrypt(data, secretKey, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
  return JSON.parse(decryptedData)
}
// 文件预览
export const getfileViewUrl = (fileUrl: string) => {
  return `${(window as any).__environment_config__?.kkfileViewUrl || 'https://kkfileview.mingzhongdata.com/'}onlinePreview?url=${encodeURIComponent(encode(fileUrl))}`
}
